require("../sass/style.scss");
require('../fonts/fontello/css/fontello.css');

require('./vendor/bootstrap-transition');
require('./vendor/bootstrap-collapse');
require('./vendor/TweenMax.min.js');
require('./vendor/parallax_content.js');
require('./vendor/wp_nav.es6');
require('./vendor/lem_counter.js');
require('./vendor/jquery.isonscreen.js');
require('./vendor/masonry.pkgd.min.js');
require('./vendor/slick.min.js');
require('./vendor/isotope.pkgd.min.js');
require('./vendor/tab.js');

require('./custom/google-map.es6');
require('./custom/leadership.es6');
require('./custom/LoadMorePosts.es6');

require('./lineAnimation.es6');

(function ($) {

    //************************************
    // Masonry layout for testimonials
    //************************************

    $('.testimonials').masonry({
        itemSelector: '.masonry',
        //columnWidth: 1,
        horizontalOrder: true
    });

    //************************************
    // Masonry layout for testimonials
    //************************************

    $('.section-latest-posts__post-list').masonry({
        itemSelector: '.section-latest-posts__post-item',
        columnWidth: 1,
        horizontalOrder: true
    });

    //************************************
    // Following organizations list
    //************************************

    var margin_step = 0;

    $('.section-following-organizations-list .organization').each(function () {
        $(this).css("margin-left", margin_step + "px");
        margin_step += 25;
    });

    //************************************
    // Fixed header when scroll
    //************************************

    $(window).on('scroll load', function () {
        if ($(window).scrollTop() >= 20) {
            $('header').addClass('fixed');
        }
        else $('header').removeClass('fixed');
    });

    //************************************
    // parallax content
    //************************************

    $('.parallaxbottom').parallaxContent({
        shift: 20,
        duration: .5
    });

    $('.parallaxtop').parallaxContent({
        shift: -20,
        duration: .5
    });

    // ==============================================================
    // Is on screen
    // ==============================================================

    function is_on_screen_item_init() {

        var is_on_screen_item = $('.is_on_screen_item');

        if (is_on_screen_item.length > 0) {
            check_is_on_screen_item();
        }

        $(document).on('scroll load resize', function (event) {

            if (is_on_screen_item.length > 0) {
                check_is_on_screen_item();
            }
        });


        function check_is_on_screen_item() {

            is_on_screen_item.each(function (i) {

                var _ = $(this);

                if (_.isOnScreen(0.4, 0.4)) {
                    _.addClass('is_on_screen');
                }

            });
        }
    }


    $(window).on('load resize', function () {
        is_on_screen_item_init();
    });

    //************************************
    // Counter
    //************************************


    $(document).on('scroll', function () {
        conter_up();
    });

    conter_up();

    function conter_up() {
        $('.section-who-we-are ul .number span:not(.viewed)').each(function () {
            var $this = $(this);

            if ($this.isOnScreen(0.3, 0.3)) {
                $this.lemCounter({
                    value_to_from_content: true,
                    locale: 'en'
                }).addClass('viewed');
            }
        });
    }


    //************************************
    // main menu scroll to other page and on the same page
    //************************************

    function onload_page_scroll() {

        //var $header_height = $('.header').outerHeight();

        var doc_location = document.location.href;
        if (doc_location.indexOf("#") + 1) {
            var location_section = doc_location.split('#')[1];
            if (location_section != 'results') {
                $("html, body").animate({scrollTop: $("#" + location_section).offset().top - 150}, 700);
            }
        }
    }

    $(window).on('load', function () {
        onload_page_scroll();
    });


    //************************************
    // body add class "is-touch" when touch device
    //************************************

    function is_touch_device() {
        try {
            document.createEvent("TouchEvent");
            $('body').addClass('is-touch');
        } catch (e) {

        }
    }

    is_touch_device();


    //************************************
    // section blog
    //************************************

    let $postList = $('.section-latest-posts__post-list');
    let $loadMoreBtn = $('.section-latest-posts__load-more-btn');


    $loadMoreBtn.loadMorePosts({
        action: 'get_more_posts',
        onLoad: function(data){
            let $data = $(data.items);
            $postList.isotope()
                .append($data)
                .isotope( 'appended', $data)
                .isotope('layout');

            setTimeout(function(){
                $postList.isotope().isotope('layout');
            }, 600)

        }
    });

    $loadMoreBtn.on('click', function (e) {
        e.preventDefault();
        $(this).loadMorePosts('loadMore');
    });

    $loadMoreBtn.on('loadMorePost.noMorePosts', function(){
        $(this).addClass('no-more-posts');
    });

    $loadMoreBtn.on('loadMorePost.beforeSend', function(){
        $(this).text('Loading ...');
        $(this).addClass('loading');
    });

    $loadMoreBtn.on('loadMorePost.success loadMorePost.error', function(){
        $(this).text('See more');
        $(this).removeClass('loading');
    })


})(jQuery);


// WEBPACK FOOTER //
// ./src/js/entry.es6